export const UNIMPAIRED_STYLE_CLASS_NAME = 'unimpaired-style';
